var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('Slider',{class:_vm.$style.slider,attrs:{"disable-dots":!_vm.isMobile,"disable-arrows":true,"options":{
      perView: 1,
      gap: 16,
      breakpoints: {
        670: {
          perView: 1.6,
        },
        750: {
          perView: 2.5,
        },
        1130: {
          perView: 3,
        },
        1264: {
          perView: 5,
        },
      },
    },"is-vertical":!_vm.isMobile}},_vm._l((_vm.combinedImages),function(image){return _c('div',{key:image,class:[
        _vm.$style.thumbnailWrapper,
        _vm.currentImage === image ? !_vm.isMobile && _vm.$style.selected : '' ]},[(_vm.isMobile && _vm.packshot === image)?_c('Packshot',{class:_vm.$style.currentImage,style:({ height: '220px', width: '220px' }),attrs:{"src":_vm.packshot,"text":_vm.petName,"text-offset":_vm.textOffset}}):_c('TwicImg',{class:_vm.$style.thumbnail,attrs:{"src":image,"ratio":"1"},nativeOn:{"mouseover":function($event){return _vm.changeCurrentImage(image)}}})],1)}),0),(!_vm.isMobile && _vm.packshot && _vm.isPackshotImage)?_c('Packshot',{class:_vm.$style.currentImage,attrs:{"src":_vm.currentImage,"text":_vm.petName,"text-offset":_vm.textOffset,"label":_vm.$i18n('🇫🇷 Fabriqué en France')}}):(!_vm.isMobile)?_c('TwicImg',{class:_vm.$style.currentImage,attrs:{"src":_vm.currentImage,"zoom":"1.2","ratio":"0.95"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }